import { render, staticRenderFns } from "./dialog-team-detail.vue?vue&type=template&id=42e948ee&scoped=true"
import script from "./dialog-team-detail.vue?vue&type=script&lang=js"
export * from "./dialog-team-detail.vue?vue&type=script&lang=js"
import style0 from "./dialog-team-detail.vue?vue&type=style&index=0&id=42e948ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e948ee",
  null
  
)

export default component.exports